<template>
	<v-card :elevation="1" class="background-2 round-card">
        <v-card-title class="pa-3">
			<p class="pl-2 pl-xl-3">Interventi</p>
	        <v-spacer></v-spacer>
			<v-text-field
				class="hidden-xs-only font-weight-regular mr-4"
				append-icon="search"
				label="Cerca"
				v-model="search"
				clearable
				hide-details
				outlined
				dense
				style="max-width: 450px"
			></v-text-field>
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="expand = !expand" icon>
						<v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
					</v-btn>
				</template>
				<span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
			</v-tooltip>
        </v-card-title>            
	    <v-divider></v-divider>
		<confirm-dialog-v-2
			:value.sync="confirmDelete"
			:data="deletingItem"
			@confirm="destroy"
		></confirm-dialog-v-2>

		<v-container class="py-0" fluid>
			<v-row class="ma-0">
				<v-col cols="12" class="hidden-sm-and-up pa-3">
					<v-text-field 
						class="font-weight-regular mr-4"
						append-icon="search"
						label="Cerca"
						v-model="search"
						clearable
						hide-details
						outlined
						dense
					></v-text-field>
				</v-col>
			</v-row>
		</v-container>		
		<v-expand-transition>
			<v-data-table
				class="background-2"
				v-show="expand"
				:headers="headers"
				:items="filteredCollection"
				:expanded.sync="expanded"
				show-expand
				item-key="id"
				:mobile-breakpoint="0"
				:footer-props="{
					'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }]
				}">
				<template v-slot:item="{ item, expand, isExpanded, headers }">
					<tr @click="expand(! isExpanded)" class="cursor-pointer">
						<template v-for="(header, h) in headers">
							<td v-if="header.value === 'actions'" :style="{'padding': 0, 'width': header.width + 'px'}" :key="h">
								<!-- Desktop: pulsanti inline -->
								<template v-if="$vuetify.breakpoint.smAndUp">
									<generate-intervention-button
										:button="button"
										:params="button.params"
										:model="item"
									></generate-intervention-button>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn v-on="on"
												icon
												small
												class="mr-2"
												@click.stop="askDelete(item)">
												<v-icon color="pink">delete</v-icon>
											</v-btn>
										</template>
										<span>Elimina</span>
									</v-tooltip>
									<create-dialog-button
										model-def="ddts"
										:default-input="getDdtDefaultInput(item)"
										query-params="template_data=template_data_ticket_ddt"
										icon="mdi-truck-delivery"
										tooltip-text="Crea DDT"
										dialog-title="Creazione DDT"
										button-color="amber"
										small
										update-event="updateTroubleShow"
									></create-dialog-button>
								</template>
								<!-- Mobile: pulsante per aprire bottom sheet -->
								<template v-else>
									<v-btn icon @click.stop="openMobileActions(item)">
										<v-icon>mdi-dots-vertical</v-icon>
									</v-btn>
								</template>
							</td> 
							<td v-else-if="header.type == 'currency'" :key="h">
								{{ item[header.value] | currency }}
							</td>
							<td v-else-if="header.type == 'date'" :key="h">
								{{ item[header.value] | date }}
							</td>	
							<td v-else-if="header.type == 'duration'" :key="h">
								{{ item[header.value] | duration }}
							</td>
							<td v-else-if="header.type == 'boolean'" :key="h">
								{{ item[header.value] ? 'Sì' : 'No' }}
							</td>
							<td v-else :key="h">
								{{ item[header.value] }}
							</td>
						</template>
					</tr>
				</template>
				<template v-slot:expanded-item="{ headers, item }">
					<td :colspan="headers.length + 1" class="pa-0 background-1">
						<!-- Descrizione Intervento -->
						<v-card class="elevation-0 ma-1 pa-0 background-1" v-if="item.description">
							<v-card-subtitle class="py-1 px-2 caption font-weight-medium">Descrizione</v-card-subtitle>
							<div class="px-2 pb-2" v-html="item.description"></div>
							<v-divider></v-divider>
						</v-card>
						<!-- Prodotti Intervento -->
						<v-card class="elevation-0 ma-1 pa-0 background-1" v-if="productsPerIntervention[item.id] && productsPerIntervention[item.id].length">
							<v-card-subtitle class="py-1 px-2 caption font-weight-medium">Prodotti Intervento</v-card-subtitle>
							<v-simple-table dense class="background-1 compact-table">
								<thead>
									<tr>
										<th class="px-2 py-1">Codice</th>
										<th class="px-2 py-1">Nome</th>
										<th class="px-2 py-1">Quantità</th>
										<th class="px-2 py-1">Prezzo</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="product in productsPerIntervention[item.id]" :key="product.id">
										<td class="px-2 py-1">{{ product.code }}</td>
										<td class="px-2 py-1">{{ product.name }}</td>
										<td class="px-2 py-1">{{ product.quantity }}</td>
										<td class="px-2 py-1">{{ product.price | currency }}</td>
									</tr>
								</tbody>
							</v-simple-table>
						</v-card>
						<!-- Prodotti DDT -->
						<v-card class="elevation-0 ma-1 pa-0 background-1" v-if="item.ddt_products && item.ddt_products.length">
							<v-card-subtitle class="py-1 px-2 caption font-weight-medium">Prodotti DDT</v-card-subtitle>
							<v-simple-table dense class="background-1 compact-table">
								<thead>
									<tr>
										<th class="px-2 py-1">Codice</th>
										<th class="px-2 py-1">Nome</th>
										<th class="px-2 py-1">Quantità</th>
										<th class="px-2 py-1">Prezzo</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="product in item.ddt_products" :key="'ddt-' + product.id">
										<td class="px-2 py-1">{{ product.code }}</td>
										<td class="px-2 py-1">{{ product.name }}</td>
										<td class="px-2 py-1">{{ product.quantity }}</td>
										<td class="px-2 py-1">{{ product.price | currency }}</td>
									</tr>
								</tbody>
							</v-simple-table>
						</v-card>
						<v-card class="elevation-0 ma-1" v-if="!hasProducts(item)">
							<v-card-text class="pa-2 text--secondary">Nessun prodotto associato</v-card-text>
						</v-card>
					</td>
				</template>
				<template v-slot:footer.page-text="{ pageStart, pageStop }">
					Da {{ pageStart }} a {{ pageStop }} di {{ filteredCollection.length }}
				</template>
			</v-data-table>
		</v-expand-transition>
		<v-container class="py-3 px-3" v-if="totals && !totalsHidden">
			<totals-cards :totals-fields="computedTotalsFields" :data="totals"></totals-cards>
		</v-container>

		<!-- Mobile: Bottom Sheet per azioni -->
		<v-bottom-sheet v-model="mobileActionsSheet">
			<v-sheet class="pa-3">
				<div class="text-center mb-2">
					<v-chip small class="mb-2" v-if="mobileActionsItem">
						Intervento {{ mobileActionsItem.operator }}
					</v-chip>
				</div>
				<v-list>
					<v-list-item @click="handleMobileEdit">
						<v-list-item-icon class="mr-4">
							<v-icon color="teal">edit</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="pl-4">
							<v-list-item-title>Modifica Intervento</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item @click="handleMobileDelete">
						<v-list-item-icon class="mr-4">
							<v-icon color="pink">delete</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="pl-4">
							<v-list-item-title>Elimina Intervento</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item @click="handleMobileCreateDdt">
						<v-list-item-icon class="mr-4">
							<v-icon color="amber">mdi-truck-delivery</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="pl-4">
							<v-list-item-title>Crea DDT</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<v-btn block text class="mt-2" @click="mobileActionsSheet = false">
					Annulla
				</v-btn>
			</v-sheet>
		</v-bottom-sheet>

		<!-- Mobile: Dialog Modifica Intervento -->
		<generate-intervention-button
			v-if="mobileEditDialog && mobileEditItem"
			:button="button"
			:params="button.params"
			:model="mobileEditItem"
			:auto-open="true"
			@close="mobileEditDialog = false; mobileEditItem = null"
		></generate-intervention-button>

		<!-- Mobile: Dialog Creazione DDT -->
		<create-dialog-button
			v-if="mobileDdtDialog && mobileDdtItem"
			model-def="ddts"
			:default-input="getDdtDefaultInput(mobileDdtItem)"
			query-params="template_data=template_data_ticket_ddt"
			icon="mdi-truck-delivery"
			tooltip-text="Crea DDT"
			dialog-title="Creazione DDT"
			button-color="amber"
			update-event="updateTroubleShow"
			:auto-open="true"
			@close="mobileDdtDialog = false; mobileDdtItem = null"
		></create-dialog-button>
	</v-card>
</template>


<script>
	import TotalsCards from '@/components/common/TotalsCards'
    import GenerateInterventionButton from '@/components/modules/tickets/GenerateInterventionButton'

    export default {
		name: 'trouble-interventions',
        components: {
			TotalsCards,
            GenerateInterventionButton,
        },
        props: {
            collection: Array,
            headers: Array,
            totals: Object,
			parent: Object,
			totalsFieldsConfig: {
				type: Array,
				default: null
			},
			totalsHidden: {
				type: Boolean,
				default: false
			},
			interventionProducts: {
				type: Array,
				default: () => []
			}
        },
        data() {
            return {
                model: {},
                url: 'troubles/',
				subFilters: {troubles: this.id},
				expand: true,
				confirmDelete: false,
				deletingItem: {},
				search: '',
				expanded: [],
				button: {
					params: {
						'icon': 'edit',
						'button_color': 'teal',
						'edit': true,
					}
				},
				// Mobile: bottom sheet e dialogs
				mobileActionsSheet: false,
				mobileActionsItem: null,
				mobileEditDialog: false,
				mobileEditItem: null,
				mobileDdtDialog: false,
				mobileDdtItem: null
            }
        },


        computed: {
			computedTotalsFields() {
				return this.totalsFieldsConfig || []
			},

			productsPerIntervention() {
				const map = {}
				this.interventionProducts.forEach(product => {
					if (!map[product.intervention_id]) {
						map[product.intervention_id] = []
					}
					map[product.intervention_id].push(product)
				})
				return map
			},

			filteredCollection() {
				if (!this.search) return this.collection
				const searchLower = this.search.toLowerCase()

				return this.collection.filter(intervention => {
					// Cerca nei campi intervento
					const matchIntervention =
						intervention.operator?.toLowerCase().includes(searchLower) ||
						intervention.description?.toLowerCase().includes(searchLower) ||
						intervention.type_text?.toLowerCase().includes(searchLower)

					// Cerca nei prodotti dell'intervento
					const products = this.productsPerIntervention[intervention.id] || []
					const matchProducts = products.some(p =>
						p.name?.toLowerCase().includes(searchLower) ||
						p.code?.toLowerCase().includes(searchLower)
					)

					return matchIntervention || matchProducts
				})
			},

            calcInterventionDuration() {
                let minutes = 0
                _.forEach(this.collection, (intervention) => {
                    minutes += intervention.duration_minutes
                })
                return minutes
            },
		},

		methods: {
			hasProducts(item) {
				const interventionProducts = this.productsPerIntervention[item.id] || []
				const ddtProducts = item.ddt_products || []
				return interventionProducts.length > 0 || ddtProducts.length > 0
			},

			getDdtDefaultInput(item) {
				return {
					intervention_id: item.id,
					company_id: this.parent ? this.parent.company_id : null,
					project_id: this.parent ? this.parent.project_id : null,
					destination_id: this.parent ? this.parent.destination_id : null
				}
			},

			askDelete(item) {
				this.deletingItem = item
				this.confirmDelete = true
			},

			destroy() {
				this.axios.post('interventions/delete', {ids: [this.deletingItem.id]}).then((response) => {
					this.$eventBusUtility.$emit('updateTroubleShow')
					this.deletingItem = {}
					this.$store.commit('setSnackbar', {timeout: 3000, text: 'Intervento eliminato con successo.', value: true, color: 'success'})
				})
			},

			// Mobile: apre bottom sheet azioni
			openMobileActions(item) {
				this.mobileActionsItem = item
				this.mobileActionsSheet = true
			},

			// Mobile: gestisce modifica dal bottom sheet
			handleMobileEdit() {
				this.mobileActionsSheet = false
				this.mobileEditItem = this.mobileActionsItem
				this.mobileEditDialog = true
			},

			// Mobile: gestisce eliminazione dal bottom sheet
			handleMobileDelete() {
				this.mobileActionsSheet = false
				this.askDelete(this.mobileActionsItem)
			},

			// Mobile: gestisce creazione DDT dal bottom sheet
			handleMobileCreateDdt() {
				this.mobileActionsSheet = false
				this.mobileDdtItem = this.mobileActionsItem
				this.mobileDdtDialog = true
			}
		},
		
		created() {
			if (this.$store.getters.checkSettings('compact_trouble_view')) {
				this.expand = true
			} else {
				this.expand = !this.$store.getters.checkSettings('compact_viewing')
			}
		}

    }
</script>